"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var count = 0;
/**
 * Lock the body overflow with this simple hook
 */

var useLockBodyScroll = function useLockBodyScroll(lock) {
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      var body = window.document.body;

      if (lock) {
        count = count + 1;
        body.style.overflow = 'hidden';
        return function () {
          count = count - 1;

          if (count === 0) {
            body.style.overflow = 'auto';
          }
        };
      }
    }
  }, [lock]);
};

__signature__(useLockBodyScroll, "useEffect{}");

var _default = useLockBodyScroll;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(count, "count", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLockBodyScroll.ts");
  reactHotLoader.register(useLockBodyScroll, "useLockBodyScroll", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLockBodyScroll.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLockBodyScroll.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();